import { Navigate, useLocation } from 'react-router-dom';

// Client-side redirect that keeps the query string and hash, so ad-click IDs (gclid/wbraid/gbraid) and UTMs survive.
export default function KeepQueryNavigate({ to }) {
  const { search, hash } = useLocation();
  const [path, toHash] = to.split('#');
  return <Navigate to={`${path}${search || ''}${toHash ? `#${toHash}` : hash || ''}`} replace />;
}
